import { render, staticRenderFns } from "./AppStudents.vue?vue&type=template&id=91dab862&lang=pug&"
import script from "./AppStudents.vue?vue&type=script&lang=ts&"
export * from "./AppStudents.vue?vue&type=script&lang=ts&"
import style0 from "./AppStudents.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AppStudents.vue"
export default component.exports